const SectionContent = {
  topSection: {
    en: {
      slogan: 'The Ultimate All-In-One Restaurant POS System',
      sloganSubTitle: 'Built for the community, by the community',
      whyLoveChowbus: `Why
      Restaurants
      Love Chowbus`,
      points: [
        ['Connected.', 'Save $8,000/mo on Labor Per Location'],
        ['Comprehensive.', 'Grow Your Business 25%'],
        ['Easy-to-Use.', '24/7 Customer Support'],
      ],
      videoUrl: `chowbus_introduction_en_720.mp4`,
    },
    zh: {
      slogan: 'Chowbus餐馆电脑：专为亚洲餐厅定制的餐馆电脑',
      sloganSubTitle: '',
      whyLoveChowbus: `为什么
      餐饮业
      爱Chowbus`,
      points: [
        ['更高效的运营策略.', '为餐馆节省近$100k/年的人力开销'],
        ['更全面的产品方案.', '多样的产品组合帮助您解决不同痛点'],
        ['更友好的使用体验.', '简单的交互以实现无痛学习、轻松上手'],
      ],
      videoUrl: `chowbus_introduction_cn_720.mp4`,
    },
  },
  whyNotChooseChowBus: {
    en: {
      title: 'Why Restaurants Choose Chowbus',
    },
    zh: {
      title: '他们选择Chowbus餐馆电脑的原因',
    },
  },
};

export default SectionContent;
